import React, {useEffect, useState} from 'react'

import {
  DSelect,
  HDatePicker,
  HInput,
  HSelect,
  passParamsThrough
} from '../../../validation/HForm'
import { translationRuEnSameLetters } from '../../../helpers/common';
import {useDispatch, useSelector} from 'react-redux';
import {searchGovernmentAgency} from '../../../redux/actions/searchAction';
import {documentTypesUser} from "../../../helpers/data-constants";

const UserDocumentsAdd = ({control, register, errors, setValue}) => {

  const props = {
    control,
    register,
    errors,
  };

  const { governmentAgency } = useSelector(({ search }) => search);
  const [authority, setAuthority] = useState([{ value: 0, label: null }])
  const dispatch = useDispatch();

  useEffect(() => {
    if (governmentAgency.length) {
      setAuthority((prev) => [prev[0], ...governmentAgency.map((i) => ({ value: i.code, label: i.authority }))])
    } else {
      setAuthority((prev) => [prev[0]]);
    }
  }, [governmentAgency]);

  const handleGetGovAgency = (e, action) => {
    if (action.action === 'input-change' && e.length >= 2) {
      dispatch(searchGovernmentAgency( {"term": e}));
    }
    setAuthority((prev) => [{ value: 0, label: e }, ...prev.slice(1)]);
  };

  return (
    passParamsThrough(
      <fieldset>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="documentType">Тип</label>
              <div className="form-element-data">
                <HSelect
                  h="true"
                  className="input"
                  type="text"
                  name="documentType"
                  id="documentType"
                  options={['', ...documentTypesUser]}
                />
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="documentNumber">Номер</label>
              <div className="form-element-data">
                <HInput
                  h="true"
                  className="input"
                  type="text"
                  name="documentNumber"
                  id="documentNumber"
                  onChange={(event) => translationRuEnSameLetters(event, setValue, "documentNumber")}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="startDate">Дата выдачи</label>
              <div className="form-element-data date">
                <HDatePicker
                  h="true"
                  className="input"
                  name="startDate"
                  id="startDate"
                />
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="endDate">Срок действия</label>
              <div className="form-element-data date">
                <HDatePicker
                  h="true"
                  className="input"
                  name="endDate"
                  id="endDate"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="form-element">
          <label className="form-element-label" htmlFor="authority">Орган, выдавший документ</label>
          <div className="form-element-data combobox combobox__bottom">
            <DSelect
              h="true"
              name="authority"
              options={authority}
              handleOptions={handleGetGovAgency}
              placeholder=""
            />
          </div>
        </div>
      </fieldset>, props)
  )

}

export default UserDocumentsAdd
